import { useState } from 'react'
import classNames from 'classnames/bind'
import SquareImage from 'components/SquareImage'
import { Swiper, SwiperSlide } from 'swiper/react'
import SwiperCore, { Thumbs, FreeMode } from 'swiper'

import { ProductPictureFragment } from './graphql/__generated__/ProductPictureFragment'

import 'swiper/css'
import 'swiper/css/thumbs'
import 'swiper/css/free-mode'
import styles from './ProductPictures.module.css'

const cx = classNames.bind(styles)

const ProductPictures = ({ pictures }: { pictures: ProductPictureFragment[] }) => {
  const [activeIndex, setActiveIndex] = useState(0)
  const [thumbsSwiper, setThumbsSwiper] = useState<SwiperCore>()

  return (
    <div className={styles.container}>
      {/* No images, show just the single image frame */}
      {pictures.length === 0 && (
        <div className={styles.singleImageContainer}>
          <SquareImage />
        </div>
      )}

      {/* Single image, show just the single image */}
      {pictures.length === 1 && (
        <div className={styles.singleImageContainer}>
          <SquareImage src={pictures[0].photoUrl} alt={pictures[0].product?.name || ''} />
        </div>
      )}

      {/* Multiple Images, use swiper */}
      {pictures.length > 1 && (
        <>
          <Swiper
            grabCursor
            onActiveIndexChange={swiper => setActiveIndex(swiper.activeIndex)}
            className={styles.swiper}
            spaceBetween={50}
            slidesPerView={1}
            modules={[Thumbs]}
            /* https://github.com/nolimits4web/swiper/issues/5630#issuecomment-1111418301 */
            thumbs={{ swiper: thumbsSwiper && !thumbsSwiper.destroyed ? thumbsSwiper : null }}>
            {pictures.map(picture => (
              <SwiperSlide key={picture.id}>
                <SquareImage src={picture.photoUrl} alt={picture.product?.name || ''} />
              </SwiperSlide>
            ))}
          </Swiper>

          <Swiper
            freeMode
            watchSlidesProgress
            onSwiper={setThumbsSwiper}
            className={styles.thumbsSwiper}
            direction="horizontal"
            modules={[FreeMode, Thumbs]}
            slidesPerView="auto"
            breakpoints={{
              768: {
                direction: 'vertical'
              }
            }}>
            {pictures.map((picture, index) => (
              <SwiperSlide key={picture.id} className={styles.thumbsSwiperSlide}>
                <div className={cx(styles.thumbnail, { thumbnailActive: index === activeIndex })}>
                  <SquareImage cover src={picture.gridPhotoUrl} alt={picture.product?.name || ''} />
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </>
      )}
    </div>
  )
}

export default ProductPictures
